// ---
import {Pracovnik} from "@mc/mc-legacy";
import FlowConfigurationVO from "../api/gen/qsign/types/FlowConfigurationVO";

/**
 * Získání jména pracovníka (pokud není k dispozici, zobrazí loginName).
 */
export function getPracovnikLabel(pracovnik) {
  if (pracovnik) {
    const uplneJmeno = pracovnik.uplneJmeno;
    return uplneJmeno && uplneJmeno.length > 0 ? uplneJmeno : pracovnik.loginName;
  } else {
    return "-";
  }
}
export function getPracovnikOrganizacniJednotkaLabel(pracovnik: Pracovnik): string {
    if (pracovnik) {
        const uplneJmeno = pracovnik.uplneJmeno;
        const organizacniJednotka = pracovnik.organizacniJednotka;
        return uplneJmeno + (organizacniJednotka ? " (" + organizacniJednotka.kod + ")" : "");
    } else {
        return "-";
    }
}
export function cleanSteps(steps) {
    for (let i = 0; i < steps.length; i++) {
        let step = steps[i];
        let approvers = step.approvers;
        for (let i = 0; i < approvers.length; i++) {
            let approver = approvers[i];
            if (approver.pracovnikId === null) {
                approvers.splice(approver);
            }
        }
        if (approvers.length < 1) {
            steps.splice(step);
        }
    }
    return steps;
}
export function cleanSigners(signers) {
    for (let i = 0; i < signers.length; i++) {
        let signer = signers[i];
        if (signer.pracovnik === undefined) {
            signers.splice(signer);
        }
    }
    return signers;
}
export function isWindows() {
    const platform = window.navigator.platform,
        windowsPlatforms = ['Win32', 'Win64', 'Windows'];
    return windowsPlatforms.indexOf(platform) !== -1;
}
